import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { jqxButtonComponent } from 'jqwidgets-ng/jqxbuttons';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxTreeComponent } from 'jqwidgets-ng/jqxtree';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MenuService } from 'src/app/services/menu/menu.service';
import { MenuModel } from 'src/app/services/sso/models/menu.model';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { environment } from 'src/environments/environment';
import { ModuloModel, ModuloOptionsModel } from '../../services/sso/models/modulo.model';
import { MainComponent } from '../main/main.component';
import { TextoModel } from 'src/app/services/sso/models/texto.model';
import { CrudService } from 'src/app/services/crud/crud.service';


@Component({
  selector: 'app-modulos-menu',
  templateUrl: './modulos-menu.component.html',
  styleUrls: ['./modulos-menu.component.css']
})
export class ModulosMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('grid') grid: jqxGridComponent;
  @ViewChild('btnMas') btnMas: jqxButtonComponent;
  @ViewChild('menuOrigin') menuOrigin: jqxTreeComponent;
  @ViewChild('menuDel') menuDel: jqxTreeComponent;
  @ViewChild('menuFinal') menuFinal: jqxTreeComponent;
  @ViewChild('chbSoloMovisat') chbSoloMovisat: ElementRef;
  @ViewChild('ebNombre') ebNombre: jqxInputComponent;
  @ViewChild('ebObserv') ebObserv: jqxInputComponent;

  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');
  opcVisible: boolean = false;
  private componentRef = null;
  public imageDelete = '/assets/images/btnDelete.png';
  public theme = environment.tema;
  //grid
  dataAdapter: any;
  dataSource: any;
  dataSourceOri: any;
  dataAdapterOri: any;
  recordsOri: any;
  recordsFin: any;
  rowIndexSelec: number;
  dataSourceFin: any;
  dataAdapterFin: any;
  //modulo
  opcionSelec: ModuloOptionsModel;
  moduloSelec: ModuloModel;
  newModulo: ModuloModel = new ModuloModel();
  moduloIdSelec: number;
  //menus
  public modulos: ModuloModel[] = [];
  public menus: MenuModel[] = [];
  //edit/insert
  editModulo: boolean = true;
  // Textos
  public textos: TextoModel[] = [];
  public textoSeleccionado = '';
  public idsOriginales = new Map<string, number>();

  constructor(
    private menuService: MenuService,
    private modal: NzModalService,
    private crudService: CrudService) { }

  async ngAfterViewInit(): Promise<void> {
    this.getTextos();
    this.getModulos();
  }

  ngOnInit(): void {
    this.opcionSelec = new ModuloOptionsModel(null, null, null, null, '', '', false, '', null, 0);
  }

  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  async getTextos() {
    this.textos = await this.crudService.getTextos(1);
  }

  //creo la columna del grid
  public columns = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', hidden: true, witdh: 'auto' },
    {
      text: 'Nombre', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 'auto',
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }], //agrego el total al grid
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    { text: 'Observaciones', columntype: 'textbox', filtertype: 'textbox', datafield: 'observaciones', width: 340 }
  ];

  //cargo los modulos
  async getModulos() {
    this.menus = await this.menuService.getMenus();
    this.modulos = await this.menuService.getModulos();
    if (this.modulos) {
      this.dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'number', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' },
          { name: 'observaciones', type: 'string', map: 'Observaciones' },
        ],
        localdata: this.modulos,
      }
      this.dataAdapter = new jqx.dataAdapter(this.dataSource)
    }
  }

  //cargo las opciones del menu maestro
  initMenuOri() {
    this.dataSourceOri = {
      datatype: 'json',
      datafields:
        [
          { name: 'Id', type: 'string', map: 'Id' },
          { name: 'PadreId', type: 'string', map: 'PadreId' },
          { name: 'TextoId', type: 'string', map: 'TextoId' },
          { name: 'Orden', type: 'string', map: 'Orden' },
          { name: 'AccionId', type: 'string', map: 'AccionId' }
        ],
      id: 'Id',
      localdata: this.menus[0].Opciones //cogeme las opciones del menu maestro
    };
    this.dataAdapterOri = new jqx.dataAdapter(this.dataSourceOri, { autoBind: true });
    this.recordsOri = this.dataAdapterOri.getRecordsHierarchy('Id', 'PadreId', 'items',
      [
        { name: 'Id', map: 'id' },
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' }
      ]);
    if (!this.recordsOri) {
      this.recordsOri = [];
    }
    // Coloco los tooltips con el texto
    setTimeout(() => {
      const items: any = this.menuOrigin.getItems();
      if (items) {
        items.forEach(element => {
          element.OpcionOriginalId = element.id;
          const ti = this.textos.find(x => x.Id === element.label);
          element.titleElement.attr('title', ti ? ti.Texto : '');
        });
      }
    }, 1000);
  }

  initModuloEdit(index: number) {
    this.dataSourceFin = {
      datatype: 'json',
      datafields:
        [
          { name: 'Id', type: 'string', map: 'Id' },
          { name: 'ModuloId', type: 'string', map: 'ModuloId' },
          { name: 'PadreId', type: 'string', map: 'PadreId' },
          { name: 'Orden', type: 'string', map: 'Orden' },
          { name: 'TextoId', type: 'string', map: 'TextoId' },
          { name: 'AccionId', type: 'string', map: 'AccionId' },
          { name: 'SoloMovisat', type: 'boolean', map: 'SoloMovisat' },
          { name: 'Observaciones', type: 'string', map: 'Observaciones' }
        ],
      id: 'Id',
      localdata: this.modulos[index].Opciones
    };
    this.dataAdapterFin = new jqx.dataAdapter(this.dataSourceFin, { autoBind: true });
    this.recordsFin = this.dataAdapterFin.getRecordsHierarchy('Id', 'PadreId', 'items',
      [
        { name: 'Id', map: 'id' },
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' },
        { name: 'SoloMovisat', map: 'checked' }
      ]);
    if (!this.recordsFin) {
      this.recordsFin = [];
    }
    this.idsOriginales.clear();
    this.modulos[index].Opciones.forEach(opt => {
      this.idsOriginales.set("" + opt.Id, opt.OpcionOriginalId);
    });
    // Coloco los tooltips con el texto
    setTimeout(() => {
      const items: any = this.menuFinal.getItems();
      if (items) {
        items.forEach(element => {
          element.OpcionOriginalId = this.idsOriginales.get(element.id);
          const ti = this.textos.find(x => x.Id === element.label);
          element.titleElement.attr('title', ti ? ti.Texto : '');
        });
      }
    }, 1000);
  }

  onSelectOpciones(event: any) {
    const args = event.args;
    const item: any = this.menuFinal.getItem(args.element);
    if (this.moduloSelec) {
      delete this.moduloSelec.FechaAlta;
      delete this.moduloSelec.FechaBaja;
      delete this.moduloSelec.FechaModificacion;
      if (item) {
        this.idsOriginales.set("" + item.id, item.OpcionOriginalId);
        this.chbSoloMovisat.nativeElement.checked = item.checked;
        if (this.moduloSelec.Opciones && this.moduloSelec.Opciones.length > 0) {
          for (let i = 0; i < this.moduloSelec.Opciones.length; i++) {
            if (item.id === ('' + this.moduloSelec.Opciones[i].Id)) {
              this.opcionSelec = this.moduloSelec.Opciones[i];
              break;
            }
          }
        }
        if (item.label) {
          this.textoSeleccionado = this.textos.find(x => x.Id === item.label).Texto;
        }
      }
    }
  }

  //si pulso el boton mas se muestra el grid con las opciones del menu maestro
  onCrearOpcion() {
    this.opcVisible = !this.opcVisible;
    if (this.opcVisible) {
      this.initMenuOri();
      this.btnMas.val('Menos');
    } else {
      this.btnMas.val('Más');
    }
  }

  onGuardar() {
    let itemModulos = this.menuFinal.getItems();
    if (itemModulos.length == 0) {
      MainComponent.showError('ATENCIÓN', 'No hay opciones para guardar', 2000);
      return;
    }

    switch (this.editModulo) {
      case true:
        if (!this.moduloSelec.Id) {
          MainComponent.showError('ATENCIÓN', 'Seleccione un modulo de la lista', 2000);
          return;
        }
        this.modal.confirm({
          nzTitle: '<i>ATENCION</i>',
          nzContent: 'Quiere guardar el módulo: ' + this.moduloSelec.Nombre + ' ?',
          nzCentered: true,
          nzCancelText: 'CANCELAR',
          nzOkText: 'SI',
          nzOnOk: () => {
            this.updateTree(itemModulos);
            this.moduloSelec.Nombre = this.ebNombre.val();
            this.moduloSelec.Observaciones = this.ebObserv.val();
            this.menuService.saveModulo(this.moduloSelec);
            MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
            for (let i = 0; i < this.modulos.length; i++) {
              if (this.moduloSelec.Id === this.modulos[i].Id) {
                this.modulos[i] = { ...this.moduloSelec };
                break;
              }
            }
            this.resetWindow();
          }
        });
        break;

      case false:
        this.modal.confirm({
          nzTitle: '<i>ATENCION</i>',
          nzContent: 'Quiere guardar el módulo nuevo ?',
          nzCentered: true,
          nzCancelText: 'CANCELAR',
          nzOkText: 'SI',
          nzOnOk: () => {
            this.updateTree(itemModulos);
            this.moduloSelec.Nombre = this.ebNombre.val();
            this.moduloSelec.Observaciones = this.ebObserv.val();
            this.menuService.saveModulo(this.moduloSelec);
            this.resetWindow();
            MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
            for (let i = 0; i < this.modulos.length; i++) {
              if (this.moduloSelec.Id === this.modulos[i].Id) {
                this.modulos[i] = { ...this.moduloSelec };
                break;
              }
            }
          }
        });
        break;
    }
  }

  resetWindow() {
    this.getModulos();
    this.grid.updatebounddata();
    if (this.moduloSelec) {
      this.editModulo = true;
    }
    this.ebNombre.val('');
    this.ebObserv.val('');
    this.menuFinal.clear();
    this.opcVisible = false;
    this.chbSoloMovisat.nativeElement.checked = false;
    this.btnMas.val('Más');
  }

  updateTree(itemModulos) {
    if (itemModulos && itemModulos.length > 0) {
      this.moduloSelec.Opciones = [];
      const orden: number[] = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
      const ids = new Map<string, number>();
      let id = 1;
      let oldLevel = 0;
      itemModulos.forEach((item: any) => {
        ids.set(item.id, id++);
      });

      itemModulos.forEach((item: any) => {
        if (oldLevel < item.level) {
          orden[item.level] = 1;
        }
        let mo = new ModuloOptionsModel(
          ids.get(item.id),
          this.moduloSelec.Id,
          item.level > 0 ? ids.get(item.parentId) : 0,
          orden[item.level]++,
          item.label,
          item.value,
          item.checked,
          '',
          item.level,
          item.OpcionOriginalId ? item.OpcionOriginalId : this.idsOriginales.get(item.id)
        );
        oldLevel = item.level;
        this.opcionSelec = mo;
        this.moduloSelec.Opciones.push(this.opcionSelec);
      });
    }
  }

  onDragStart(event: any) {
    this.imageDelete = '/assets/images/delete_red.png';
  }

  onDragEnd(event: any) {
    this.imageDelete = '/assets/images/btnDelete.png';
    this.menuDel.clear();
    this.chbSoloMovisat.nativeElement.checked = false;
  }


  onRowSelect(event: any) {
    this.moduloSelec = this.modulos[event.args.rowindex];
    this.moduloIdSelec = this.moduloSelec.Id;
    this.initModuloEdit(event.args.rowindex);
    this.chbSoloMovisat.nativeElement.checked = false;
    //this.newModulo = this.moduloSelec;
    this.ebNombre.val(this.moduloSelec.Nombre);
    this.ebObserv.val(this.moduloSelec.Observaciones);
    this.editModulo = true;
    if (this.moduloSelec.Opciones.length == 0) {
      this.menuFinal.clear();
    }
  }

  onChangeSoloMovisat(event: any) {
    const item = this.menuFinal.getSelectedItem();
    if (item) {
      item.checked = event.target.checked;
    }
  }

  onAddModulo() {
    this.ebNombre.val('');
    this.ebObserv.val('');
    this.moduloSelec = new ModuloModel();
    this.menuFinal.clear();
    this.chbSoloMovisat.nativeElement.checked = false;
    this.editModulo = false;
    this.ebNombre.focus();
  }

  async onBorrarMenu() {

    if (!this.moduloSelec) {
      MainComponent.showError('ATENCIÓN', 'Seleccione un menú de la lista', 2000);
      return;
    }
    if (this.moduloSelec.Id === 1) {
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>ATENCION</i>',
      nzContent: 'Quiere borrar el módulo: ' + this.moduloSelec.Nombre + ' ?',
      nzCentered: true,
      nzCancelText: 'CANCELAR',
      nzOkText: 'SI',
      nzOnOk: async () => {
        MainComponent.getInstance().showSuccess('ATENCION', 'Registro borrado', 2000);
        await this.menuService.deleteModulo(this.moduloSelec.Id);
        for (let i = 0; i < this.menus.length; i++) {
          if (this.moduloSelec.Id === this.menus[i].Id) {
            this.menus.splice(i, 1);
            break;
          }
        }
        this.getModulos();
        this.moduloSelec = null;
        this.grid.updatebounddata('cells');
        this.dataSourceFin = [];
        this.menuFinal.clear();
        this.ebNombre.val('');
        this.ebObserv.val('');
        this.chbSoloMovisat.nativeElement.checked = false;
        this.opcVisible = false;
        this.btnMas.val('Más');
      }
    });
  }

  //destruyo el componente
  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}


